export default __webpack_public_path__ + "static/Kosecki_pic-8221a8b3242bacf9b2715a89f78ecff2.jpg";